import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loading: {
    defaultMessage: 'loading',
    description: 'ordersHeader.loading',
    id: 'h7KX7Z',
  },
});
